module.exports = __webpack_public_path__ + "static/media/icon-https.c7c1e46f.svg";